// extracted by mini-css-extract-plugin
export default {"payment-method":"PaymentMethodList_payment-method__4aE0c"};